
/* eslint-disable prefer-destructuring */
/* eslint-disable jam3/no-sanitizer-with-danger */

import React, { useState, useEffect, useMemo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { makeStyles } from '@material-ui/core/styles';
import styles from './View.Style'
import Navigation from 'support/navigation'
import { useHistory } from 'react-router-dom';
import defaultPhoto from 'img/default-photo.png'
import visitImg from 'img/visits.png'
import expiresImg from 'img/expiresDateIcon.png'
import taggedImg from 'img/tagged.png'
import pendingImg from 'img/pending-review-tick.png'
import extraBenefits from 'img/extrabenefit.png'
import starImg from 'img/star-with-circle.png'
import coinsImg from 'img/coins-with-circle.png'
import chevronImg from 'img/chevron-up-purple.png'
import noDraftIdeasImg from 'img/no_draft_idea.png'
import { getStyledStatus } from 'services/GetStatusStyle'
import states from 'common_constants/idea_states_constants'
import { Container } from '@material-ui/core'
import { challengeStatuses } from '../post_challenge/View.Utils'
import i18n from 'support/i18n'
import { ControlButtons } from '../../components_newui'
import { getChallengeStatus } from '../../services/GetStatusStyle'
import navigation from '../../support/navigation'
import { BiBulb } from "react-icons/bi";

import ChallengeHeader from './ChallengeHeader'
import ChallengeMediaPanel from './ChallengeMediaPanel'
import ChallengeVideo from './ChallengeVideo'
import TaggedIdeasSection from './IdeasTaggedSection'
import ChallengeDescription from './ChallengeDescription'
import ChallengeRewards from './ChallengeRewards'
import { CommunityInvite } from './CommunityInvite';
import { SelectedCategory } from './SelectedCategory';
import { SelectedTemplateCardList } from './SelectedTemplateCardList';
import MatchedGroupNames from './MatchedGroupNames';
import Loading from 'components_newui/Loading';
import CommonDialog from 'components_newui/dialogs/CommonDialog';
import ChallengeOrganizerList from './ChallengeOrganizerList';

const { PENDING_VALIDATION } = states


const ChallengeDetails = (props) => {
  const history = useHistory();
  const {
    classes,
    challenge,
    navigateToUserProfile,
    challengePropose,
    navigateToAllChallenges,
    ideasChallenge,
    navigateToNewIdea,
    types,
    ideaStatusStepper,
    navigateToIdeaDetail,
    applySearch,
    resetSearch,
    match,
    isAdmin,
    isInnovator,
    isEvaluator,
    isLocalAdmin,
    onEditClick,
    onDeleteClick,
    onFinishClick,
    onVisitorsClick,
    sameOrigin,
    countryId,
    origin,
    listScorecardTemplate, listIdeaTemplate, innovateCategoryTypes, onEditClickInnovate,
    listCommunitesChallenge,
    submitByChallengeUserEmail,
    submitByChallengeUserName,
    submitByChallengeUserLastName,
    loginUserEmail,
  } = props || {};

  const { getIdeaTemplatelistFn, getScorecardTemplatelistFn, getInnovateChallengeActiveTypesFn, getCommunitesAsGroup } = props || {}

  const {
    approveMult = '',
    images = [],
    name = '',
    title = '',
    descWithoutTags = '',
    desc = '',
    video = '',
    ends = null,
    implementedMult = '',
    importance = '',
    numIdeas = 0,
    ideas: challengeTaggedIdea = [],
    proposerEmail = '',
    sponsorEmail = '',
    sponsorPhoto: challengeOwnerPics = '',
    proposerName = '',
    sponsorName = '',
    supportedMult = '',
    created,
    starts,
    proposedDate,
    visits = 0,
    organisation = '',
    goalMult = '',
    status = '',
    id: challengeId = '',
    isGlobal = false,
    isInnovate = false,
    challengeTemplateId = '',
    ideaTemplateId = '',
    categoryTypeId = '',
    termAndCondition,
    groupListK = [],
    challengeOrganizerEmailList=[],
  
  } = challenge || {};

  const isOrganizer = (challengeOrganizerEmailList || []).some(
    email => email.toLowerCase() === loginUserEmail?.toLowerCase()
  );

  let selectedType = null;
  try {
    if (Array.isArray(innovateCategoryTypes)) {
      selectedType = innovateCategoryTypes.find(
        (type) => Number(type.id) === Number(categoryTypeId)
      );
    } else {
      console.warn("innovateCategoryTypes is not an array.");
    }

    if (!selectedType) {
      console.warn("No matching category type found for ID:", categoryTypeId);
    }
  } catch (error) {
    console.error("Error while finding category type:", error);
  }



  // const proposerNameNotAvailable = proposerName || proposerEmail?.split('@')[0] || 'Unknown';
  // const proposerNameNotAvailable = sponsorName || sponsorEmail?.split('@')[0] || 'Unknown';


  const proposerNameNotAvailable =
    sponsorName ||
    (sponsorEmail
      ? sponsorEmail.split('@')[0].replace(/\./g, ' ')
      : null) ||
    'Unknown';


  const [showDetails] = useState(status !== PENDING_VALIDATION);
  const [activeFilters, setActiveFilters] = useState({ status: [], types: [] });
  const [dialogOpenForChallengeTnc, setDialogOpenForChallengeTnc] = useState(false);
  // const [allButtons, setAllButtons] = useState([]);
  const [showMore, setShowMore] = useState(true);
  // const [ideasTag, setIdeasTags] = useState([]);
  const [nameQuery, setNameQuery] = useState('');


  useEffect(() => {
    const { applyFilter, getChallengeById } = props;
    getChallengeById(match.params.id);
    applyFilter(match.params.id);
  }, [match.params.id]);

  useEffect(() => {
    const { applyFilter, getChallengeById } = props;
    getChallengeById(match.params.id);
    applyFilter(match.params.id, null, activeFilters.status, activeFilters.types);
  }, [activeFilters, match.params.id]);


  const onHandlePostAnIdea = () => {
    const targetPath = Navigation.navigateToInnovateIdeaSubmit();

    history.replace({
      pathname: targetPath,
      state: { challenge }
    });
  };



  const onHandleViewChallengeTnc = () => {
    setDialogOpenForChallengeTnc((prev) => !prev)
  }

  // console.log("ideasTag--", ideasTag, 'pass challenge TaggedIdea', challengeTaggedIdea)

  // useEffect(() => {
  //   setIdeasTags(challengeTaggedIdea);
  // }, []);


  const getChallengeButtons = () => {
    // const isAdmin = true;
    //  const isInnovator= false ; 
    //  const isEvaluator = false;
    const buttons = [];
    const isChallengeOwner = challenge?.sponsorEmail === loginUserEmail;
      // or userId based on your application
    const canEditOrDelete =
      isAdmin ||
      (isLocalAdmin && sameOrigin && !isGlobal) ||
      (isInnovator && isChallengeOwner) ||
      isOrganizer;

    // const canEditOrDelete = isAdmin || (isLocalAdmin && sameOrigin && !isGlobal) || isInnovator || isOrganizer;
    // const hasRole = isAdmin || isInnovator || isEvaluator || isLocalAdmin;
    const isInnovateRedict = isInnovate
    // if (!hasRole) return buttons;

    //(isInnovator && isChallengeOwner) // if innovator role exit than create and edit own challenge and if part of orginzer than can edit or submit 
    //ERIS-2391 sprint97

const isDraft = status === challengeStatuses.DRAFT;
const isActive = status === challengeStatuses.ACTIVE;
const canEditChallenge =(isDraft || isActive && (isAdmin  || isOrganizer || (isInnovator && isChallengeOwner))) 
    // || (isActive && (isAdmin || isInnovator));
// const disableEdit = isActive && isOrganizer && !isAdmin && !isInnovator;


    if (status === challengeStatuses.PROPOSED && canEditOrDelete) {
      buttons.push({
        text: i18n.t('CHALLENGES.VALIDATE'),
        action: () => onEditClick(challengeId),
      });
    }

    if (status !== challengeStatuses.DELETED) {
      if (isInnovateRedict) {
        if (canEditChallenge) {
          buttons.push({
            text: i18n.t('CHALLENGES.EDIT'),
            action:  () => onEditClickInnovate(challengeId),
            // disabled: disableEdit,
            // tooltip: disableEdit ? 'Co-organizers can edit only Draft challenges.': '',
          });
        }
      } else if (status !== challengeStatuses.PROPOSED && canEditOrDelete) {
        buttons.push({
          text: i18n.t('CHALLENGES.EDIT'),
          action: () => onEditClick(challengeId),
        });
      } else {
        return ' not found isInnovateRedict and '
      }

      // if (canEditOrDelete) {
      //   buttons.push({
      //     text: i18n.t('CHALLENGES.DELETE'),
      //     action: () => onDeleteClick(challengeId),
      //     isNotPrimary: true,
      //   });
      // }
    }

    if (status === challengeStatuses.ACTIVE && canEditChallenge) {
      buttons.push({
        text: i18n.t('CHALLENGES.FINISH'),
        action: () => onFinishClick(challengeId),
      });
    }

    // buttons.push({
    //   text: i18n.t('CHALLENGES.VISITORS'),
    //   action: () => onVisitorsClick(challengeId),
    // });

    buttons.push({
      text: "View Challenge T&C's",
      action: () => onHandleViewChallengeTnc(),
    });

    if (status === challengeStatuses.ACTIVE ) {
    buttons.push({
      isNotPrimary: true,
      text: "Post an Idea",
      action: () => onHandlePostAnIdea(),
    });}

    return buttons;
  };


  const allButtons = useMemo(() => {
    const isReady =
      status !== undefined &&
      challengeStatuses !== undefined &&
      typeof isAdmin !== 'undefined' &&
      typeof isInnovator !== 'undefined' &&
      typeof isEvaluator !== 'undefined' &&
      typeof isLocalAdmin !== 'undefined' &&
      typeof sameOrigin !== 'undefined' &&
      typeof isGlobal !== 'undefined';

    if (!isReady) return [];

    return getChallengeButtons({
      status,
      isAdmin,
      isInnovator,
      isEvaluator,
      isLocalAdmin,
      sameOrigin,
      isGlobal,
      challengeId,
      i18n,
      onEditClick,
      onDeleteClick,
      onFinishClick,
      onVisitorsClick,
      challengeStatuses,
    });
  }, [
    status,
    isAdmin,
    isInnovator,
    isEvaluator,
    isLocalAdmin,
    sameOrigin,
    isGlobal,
    challengeId,
    i18n,
    onEditClick,
    onDeleteClick,
    onFinishClick,
    onVisitorsClick,
    challengeStatuses,
  ]);


  // console.log('allButtonsallButtonsallButtonsallButtons',allButtons)

  useEffect(() => {
    if (isInnovate)
      getIdeaTemplatelistFn?.();
    getScorecardTemplatelistFn?.();
    getInnovateChallengeActiveTypesFn?.();
    getCommunitesAsGroup?.();
  }, [isInnovate]);



  const pageHierarchy = [
    { string: 'Home', navigate: () => navigation.navigateToExplore() },
    { string: 'All challenges', navigate: navigateToAllChallenges },
    { string: 'Challenge details', navigate: () => { } },
  ];

  const { name: statusStr, image: statusIcon, color: statusCol } = getChallengeStatus(status);

  const formatDate = (epochMs) => {
    const date = new Date(epochMs);
    return `${date.toLocaleDateString('en-US', { day: 'numeric' })}/${date.toLocaleDateString('en-US', { month: 'numeric' })}/${date.toLocaleDateString('en-US', { year: 'numeric' })}`;
  };

  if (!challenge || !status) {
    return <Loading />
  }



  return (
    <>
      {/* <Breadcrumbs crumbs={pageHierarchy} /> */}
      <Container>
        <main className={classes.background}>


          <ChallengeHeader
            pageHierarchy={pageHierarchy}
            allButtons={allButtons}
            name={name || title}
            statusStr={statusStr}
            statusCol={statusCol}
            challengeId={challengeId}
            classes={classes}
          />

          <ChallengeMediaPanel
            challenge={challenge}
            classes={classes}
            showDetails={showDetails}
            expiresImg={expiresImg}
            visitImg={visitImg}
            taggedImg={taggedImg}
            pendingImg={pendingImg}
            sponsorName={sponsorName}
            proposerEmail={sponsorEmail}
            proposerNameNotAvailable={proposerNameNotAvailable}
            proposedDate={proposedDate}
            challengeCreateDate={created}
            starts={starts}
            ends={ends}
            visits={visits}
            numIdeas={numIdeas}
            formatDate={formatDate}
            navigateToUserProfile={navigateToUserProfile}
          />
          {!isInnovate && showDetails && (
            <ChallengeRewards
              classes={classes}
              extraBenefits={extraBenefits}
              supportedMult={supportedMult}
              goalMult={goalMult}
              implementedMult={implementedMult}
              starImg={starImg}
              coinsImg={coinsImg}
            />
          )}

         

              <ChallengeVideo video={video} classes={classes} />

              <ChallengeDescription
                // description={descWithoutTags}
                description={desc}
                importance={importance}
                showMore={showMore}
                classes={classes}
              />


            {  (status === challengeStatuses.ACTIVE  ) ?
              <div style={{textAlign:'center'}}> 
                <button

                onClick={onHandlePostAnIdea}
                type="button"
                className={classes.postIdea}
              >
                Post an Idea
              </button> </div>

              : null 
            }

          {
            (isAdmin || isInnovator || isOrganizer ) && (<>
              <div className={classes.grid2block}>
                {listScorecardTemplate?.length > 0 ? <SelectedTemplateCardList
                  classes={classes}
                  title="Challenge Template"
                  templates={listScorecardTemplate}
                  selectedId={challengeTemplateId}
                /> : null}
                {listIdeaTemplate?.length > 0 ? <SelectedTemplateCardList
                  classes={classes}
                  title="Idea Template"
                  templates={listIdeaTemplate}
                  selectedId={ideaTemplateId}
                /> : null}
              </div>

              {selectedType?.length > 0 ? <SelectedCategory selectedType={selectedType} classes={classes} /> : null}
              {/* {sponsorEmail?.length > 0 ? <CommunityInvite challengeOwnerPics={challengeOwnerPics} sponsorEmail={sponsorEmail} classes={classes} /> : null} */}
              {groupListK.length > 0 ? <MatchedGroupNames
                groupObjects={listCommunitesChallenge}
                groupListK={groupListK}
              /> : null}
              {
               challengeOrganizerEmailList?.length > 0 ? 
               <ChallengeOrganizerList 
                challengeOrganizerEmailList={challengeOrganizerEmailList}
               />  : null
              }

            </>)
          }

          {challengeTaggedIdea?.length > 0 ?
            <TaggedIdeasSection
              // ideasTag={challengeTaggedIdea}
              // setIdeasTag={setIdeasTags}
              // ideasChallenge={ideasChallenge}
              challengeTaggedIdea={challengeTaggedIdea}
              activeFilters={activeFilters}
              setActiveFilters={setActiveFilters}
              nameQuery={nameQuery}
              setNameQuery={setNameQuery}
              classes={classes}
              noDraftIdeasImg={noDraftIdeasImg}
            /> : null}
        </main>
      </Container>

      {
        dialogOpenForChallengeTnc && (
          <CommonDialog
            open={dialogOpenForChallengeTnc}
            title="Challenge T&C's"
            cancelText='Close'
            hideSubmitBtn
            content={<div dangerouslySetInnerHTML={{ __html: termAndCondition }} />}
            onClose={() => setDialogOpenForChallengeTnc(false)}

          />
        )
      }

    </>
  );
};

export default withStyles(styles)(ChallengeDetails)


